import { Owner } from "../Viewer/Owner";
import { DeviceFilter } from "../../DiscoveryEngine.TS/Core/DeviceFilter";
import { ObjectSerializer } from "../../DiscoveryEngine.TS/Serialization/ObjectSerializer";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";


export class ViewerDeviceFilterDto implements ObjectSerializer {

	public Owner: Owner;
	public DeviceFilter: DeviceFilter;

	constructor(owner?: Owner, deviceFilter?: DeviceFilter) {
		this.Owner = (owner ? owner : Owner.System);
		this.DeviceFilter = (deviceFilter ? deviceFilter : null);
	}

	public get HasDeviceFilter(): boolean {
		return !!this.DeviceFilter;
	}

	public Write(obj: any, context: any): void {
		obj.viewer_device_filter = {};
		obj = obj.viewer_device_filter;

		obj.owner = Owner[this.Owner];

		if (this.HasDeviceFilter) {
			this.DeviceFilter.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.viewer_device_filter)
			throw new Error();
		obj = obj.viewer_device_filter;

		if (obj.owner !== undefined) {
			this.Owner = Owner[<string>obj.owner];
		}

		if (obj.device_filter !== undefined) {
			this.DeviceFilter = new DeviceFilter();
			this.DeviceFilter.Read(obj, context);
		}
	}

}